import { render, staticRenderFns } from "./BackgroundScreen.vue?vue&type=template&id=15999500&"
import script from "./BackgroundScreen.vue?vue&type=script&lang=js&"
export * from "./BackgroundScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports